import React from "react";

function ItalicIcon({ className }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="currentColor"
            className={className}
        >
            <rect width="30" height="30" fill="none" />
            <path
                d="M18.83 10.976H16.24L14.658 18.424H17.248L16.996 19.6H10.5L10.752 18.424H13.342L14.924 10.976H12.334L12.586 9.8H19.082L18.83 10.976Z"
            />
        </svg>
);
}

export default ItalicIcon;
